

















































































































































































import { Component, Prop } from "vue-property-decorator";
import axios from "axios";
import HacoBase from "../HacoBase";

@Component
export default class OptionComp extends HacoBase {
  editData: any = {};
  $debugServer!: string;
  $currentPage!: string;
  @Prop({ type: String, required: false }) private dialogText!: string;
  isNewData = 1; // 0=新規モード, 1=上書きモード
  defData: object = {
    option: {
      colorAdjustments: [
        {
          id: 0,
          colorAdjustmentName: "",
          cost: 0
        }
      ],
      foilStampingCosts: [
        {
          id: 0,
          foilStampingName: "",
          costPerMin: 0,
          fixedCost: 0
        }
      ],
      keepWoodenMoldCosts: [
        {
          id: 0,
          keepWoodenMoldName: "",
          cost: 0
        }
      ],
      sampleCosts: [
        {
          id: 0,
          sampleName: "",
          cost: 0
        }
      ],
      shareOnWebCosts: [
        {
          id: 0,
          shareOnWebName: "",
          cost: 0
        }
      ]
    }
  };

  mounted(): void {
    const url = this.$debugServer + "/api/v1_inner/option/";
    const params: object = this.setAxiosParams(url, "get");
    axios(params)
      .then((response: any): void => {
        this.editData = response.data;
      })
      .catch((error: any): void => {
        console.log("[mount error]", error.response);
        this.toLoginPage(error);
      });
  }

  checkInputKeys(e: KeyboardEvent): void {
    if (e.ctrlKey === true && e.key === "Enter") {
      this.onSubmit();
    }
  }

  onSubmit(back = false): void {
    const mes = this.$t("message.editCommon.saveConfirmation");
    const confirmation: boolean = confirm(mes as string);
    if (confirmation === false) {
      return;
    }
    const formElement: HTMLFormElement = document.getElementById(
      "editForm"
    ) as HTMLFormElement;
    if (formElement !== null && formElement.reportValidity() === false) {
      return;
    }

    const editData: any = this.editData;
    interface CategoryObj {
      category: string;
      backTo: string;
      dataName: string;
    }
    const categoryObj: CategoryObj = {
      category: "option",
      backTo: "Option",
      dataName: "option"
    };
    const id: number = parseInt(editData.option.id, 10);
    this.sendEditData(id, editData, categoryObj, back, this.afterSaving);
  }

  afterSaving(): void {
    void 0;
  }
}
